(function (window) {
  const search = document.querySelector('.js-header-search');
  const input = document.querySelector('.js-header-search-input');
  const activeClass = 'js-header-flyout-search--active';

  function handlePageLoad(e) {
    if (input.value) {
      search.classList.add(activeClass);
    }
  }

  function handleSearchInputChange(e) {
    if (e.target.value) {
      search.classList.add(activeClass);
    }
    else {
      search.classList.remove(activeClass);
    }
  }

  // Populate the input with the value of the clicked link and trigger an event.
  function handleSearchListLink(e) {
    e.preventDefault();
    input.value = e.target.text;
    triggerNativeEvent(input, 'input');
  }

  function setup() {
    const searchListLinks = search.querySelectorAll('.js-header-search-list-link');
    for (let i = 0; i < searchListLinks.length; i++) {
      searchListLinks[i].addEventListener('click', handleSearchListLink);
    }
    document.querySelector('.header-search__input').focus();
  }

  function teardown() {
    const searchListLinks = search.querySelectorAll('.js-header-search-list-link');
    for (let i = 0; i < searchListLinks.length; i++) {
      searchListLinks[i].removeEventListener('click', handleSearchListLink);
    }
  }

  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('flyout-change', function (data) {
      if (data.id !== 'search') return;

      if (data.action === 'open') {
        setup();
      } else {
        teardown();
      }
    });
  }

  if (input && search) {
    window.addEventListener('load', handlePageLoad);
    input.addEventListener('input', handleSearchInputChange);
  }

  // If search is open on load, run setup.
  // To-do: Figure out a way to do this outside this file. This is useful only
  // when viewing the mini-search component.
  if (search && search.getBoundingClientRect().height) {
    setup();
  }
})(this);
